export default __webpack_public_path__ + "static/assets/45686dbab02e5bfe8dcbbfff1198ffc6.png";